import { JobQuestionsFragment, OfferFieldsOptionsQuery } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

type IntegrationsInfojobsValueOption = NonNullable<
  NonNullable<
    NonNullable<OfferFieldsOptionsQuery['integrationsInfojobs']>['contractTypes']
  >['nodes']
>[0]

export const INITIAL_ID_VALUE = ''
export const DEFAULT_JOB_SUBINDUSTRY = '3123'

const MIN_JOB_TITLE_LENGTH = 3
const MAX_JOB_TITLE_LENGTH = 255

const MIN_JOB_DESCRIPTION_LENGTH = 100
const MAX_JOB_DESCRIPTION_LENGTH = 4000

const MIN_CITY_LENGTH = 5
const MAX_CITY_LENGTH = 500

const MIN_ZIP_LENGTH = 5
const MAX_ZIP_LENGTH = 10

const MAX_KILLER_QUESTIONS = 12
const MAX_QUESTION_OPTIONS = 5

export type JobAttributes = {
  id: string
  title?: string | null
  description?: string | null
  city?: string | null
  zip?: string | null
  questions?: JobQuestionsFragment[]
}

export const mapOptions = (options: IntegrationsInfojobsValueOption[] = []) => {
  return options.map((option) => ({
    value: option.value,
    label: option.label,
  }))
}

const validLength = (text: string | null | undefined, min: number, max: number) => {
  return text && text.length >= min && text.length <= max
}

export const checkErrors = (jobAttributes: JobAttributes) => {
  const errors: string[] = []

  const descriptionWithoutHtmlTags = jobAttributes.description?.replace(/<[^>]*>?/gm, '')

  if (!validLength(jobAttributes.title, MIN_JOB_TITLE_LENGTH, MAX_JOB_TITLE_LENGTH))
    errors.push(
      i18n.t('ats.job_details.promotion.infojobs.job.information.incorrect_fields.alert.job_title')
    )

  if (
    !validLength(descriptionWithoutHtmlTags, MIN_JOB_DESCRIPTION_LENGTH, MAX_JOB_DESCRIPTION_LENGTH)
  )
    errors.push(
      i18n.t(
        'ats.job_details.promotion.infojobs.job.information.incorrect_fields.alert.job_description'
      )
    )

  if (
    !validLength(jobAttributes.city, MIN_CITY_LENGTH, MAX_CITY_LENGTH) ||
    !validLength(jobAttributes.zip, MIN_ZIP_LENGTH, MAX_ZIP_LENGTH)
  )
    errors.push(
      i18n.t('ats.job_details.promotion.infojobs.job.information.incorrect_fields.alert.location')
    )

  if (
    jobAttributes.questions?.length != undefined &&
    jobAttributes.questions.length > MAX_KILLER_QUESTIONS
  ) {
    errors.push(
      i18n.t(
        'ats.job_details.promotion.infojobs.job.information.incorrect_fields.alert.killer_questions'
      )
    )
  }

  const numberOfOptionsExceeded = jobAttributes.questions?.some(
    (question) => question.options && question.options?.length > MAX_QUESTION_OPTIONS
  )
  if (numberOfOptionsExceeded) {
    errors.push(
      i18n.t(
        'ats.job_details.promotion.infojobs.job.information.incorrect_fields.alert.question_options'
      )
    )
  }

  return errors
}
